import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=09e4e7b0&scoped=true"
import script from "./FeedBack.vue?vue&type=script&lang=js"
export * from "./FeedBack.vue?vue&type=script&lang=js"
import style0 from "./FeedBack.vue?vue&type=style&index=0&id=09e4e7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e4e7b0",
  null
  
)

export default component.exports